/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER_VAR_NAME = feature.getSettingValue('TIMER_NAME');
    const TIMER_NAME = `timer_${feature.getSettingValue('TIMER_NAME')}`;

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        // template: `dim ${VARNAME} as ${DATATYPE}=${defaultValue}`,
        template: `dim ${TIMER_NAME} as dword=0`,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
${TIMER_NAME} = None`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
def timer_interruption_handler_${TIMER_NAME}(timer):
    #****timer_interruption_handler_${TIMER_NAME}****#
    pass`,
    });

    return blocks;
};
